// App version shown at the bottom of every page. Bump this with each release.
export const APP_VERSION = '1.0.0';
